export const SHOW_SIGN_UP_PASSWORD_POLICY = 'ab-show-signup-password-policy';

export const abExperimentData = {
  [SHOW_SIGN_UP_PASSWORD_POLICY]: 'show-policy'
};

export const getWinningVariant = (winningVariants = [], experimentName) => {
  const winnerVariant = winningVariants.find(e => e.experiment === experimentName);

  if (!winnerVariant) {
    return null;
  }

  return winnerVariant.name;
};

export default {
  getWinningVariant,
  abExperimentData
};



// WEBPACK FOOTER //
// ./src/pages/signup/abUtils.js